import { proxyCustomElement, HTMLElement, createEvent, h, Host, Fragment } from '@stencil/core/internal/client';
import { d as defineCustomElement$7 } from './button.js';
import { d as defineCustomElement$6 } from './divider.js';
import { d as defineCustomElement$5 } from './icon.js';
import { d as defineCustomElement$4 } from './layout.js';
import { d as defineCustomElement$3 } from './loader.js';
import { d as defineCustomElement$2 } from './tooltip.js';
import { d as defineCustomElement$1 } from './tooltip-label.js';

var TablePageLength;
(function (TablePageLength) {
    TablePageLength[TablePageLength["s"] = 10] = "s";
    TablePageLength[TablePageLength["m"] = 25] = "m";
    TablePageLength[TablePageLength["l"] = 50] = "l";
})(TablePageLength || (TablePageLength = {}));
var TablePaginationMode;
(function (TablePaginationMode) {
    /**
     * Pagination is never rendered.
     *
     * The page length can not be set, and the table will render as many rows as possible.
     */
    TablePaginationMode["off"] = "off";
    /**
     * Pagination will render automatically.
     *
     * It will start out hidden and appear when a total length exceeds the page length. If a new total length falls
     * below the page length later on, the pagination will be disabled instead of switching back to hidden.
     */
    TablePaginationMode["auto"] = "auto";
})(TablePaginationMode || (TablePaginationMode = {}));

const tablePageLengthInputCss = ":host{align-items:center;color:var(--jw-theme-surface-text-description-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:1.25rem}:host hr{border-color:var(--jw-theme-surface-divider-color);border-style:solid;border-width:1px;border-bottom:0;border-left:0;flex:none;margin:0;padding:0}:host span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
const WuiTablePageLengthInputStyle0 = tablePageLengthInputCss;

const WuiTablePageLengthInput = /*@__PURE__*/ proxyCustomElement(class WuiTablePageLengthInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.changePageLength = createEvent(this, "changePageLength", 3);
        this.pageLength = TablePageLength.s;
        this.pageLengths = undefined;
        this.page = 1;
        this.total = 0;
        this.disabled = undefined;
    }
    render() {
        const isCustomPageLength = !this.pageLengths?.includes(this.pageLength);
        const start = this.page * this.pageLength - this.pageLength;
        const end = Math.min(start + this.pageLength, this.total);
        return (h(Host, { key: '7e306881c45d4f8cd79a0397c45dfe4b3e1e4a47' }, !isCustomPageLength && (h(Fragment, { key: '81ab4166b7d463c9bdf208aaf6a7c6593a4cdf92' }, h("span", { key: '95d3e70dd8422fb470d53a99cc7eebce0b13c02b', class: "label" }, "Results per page"), h("wui-layout", { key: '158b0fb0f26de14a24018cf1b7f1b6420090affe', type: "button-group", variant: "button-group-tight" }, this.pageLengths?.map((pageLength) => {
            return (h("wui-button", { key: String(pageLength), type: "ghost", label: String(pageLength), toggled: pageLength === this.pageLength, disabled: this.disabled || pageLength === this.pageLength, onClick: () => {
                    this.changePageLength.emit(pageLength);
                } }));
        })), h("wui-divider", { key: '3b7bbde802134c99285cf880305f1f422128ace5', type: "vertical" }))), h("span", { key: '6a00fa516fdab68f5c70d3a7b744963b8dec3a33' }, "Showing ", start + 1, " - ", end, " of ", this.total === Number.POSITIVE_INFINITY ? '∞' : this.total, " items")));
    }
    static get style() { return WuiTablePageLengthInputStyle0; }
}, [1, "wui-table-page-length-input", {
        "pageLength": [2, "page-length"],
        "pageLengths": [16],
        "page": [2],
        "total": [2],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-table-page-length-input", "wui-button", "wui-divider", "wui-icon", "wui-layout", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-table-page-length-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTablePageLengthInput);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { TablePageLength as T, WuiTablePageLengthInput as W, defineCustomElement as d };

//# sourceMappingURL=table-page-length-input.js.map